<template>
	<div class="search" >
		<button class="btn btn-plain" @click.prevent="show">
			<svg class="ticon"><use xlink:href="/images/icons.svg#icon-search"></use></svg>
		</button>

		<transition name="fade">
			<div class="megasearch__overlay" v-if="searchShown">
				<div class="container">
					<div class="megasearch__searchbar">
						<input id="searchbar" type="text" v-model.lazy="keywords" placeholder="Search ..." v-debounce="300" class="form-control">
						<button class="btn btn-plain" @click.prevent="close">
							<svg class="ticon"><use xlink:href="/images/icons.svg#icon-close"></use></svg>
						</button>
					</div>

					<div class="megasearch__results">
						<perfect-scrollbar>
							<div class="row megasearch__results--wrapper">
								<div v-if="results.categories && results.categories.length > 0" class="col-md-4 search--results--categories">
									<p v-text="$__('strings.text.search.categories')"></p>
									<div v-for="(category, index) in results.categories" :key="index">
										<a :href="`/shop/${category.slug}`" :title="category.title" v-text="category.title"></a>
									</div>
								</div>
								<div v-if="results.products && results.products.length > 0" class="col-md-4 search--results--products">
									<p v-text="$__('strings.text.search.products')"></p>
									<div class="megasearch__results--section--wrapper">
										<div class="megasearch__results--element" v-for="(product, index) in results.products" :key="index">
											<a :href="`/product/${product.slug}`" :title="product.title">
												<img loading="lazy" :src="product.picture" :alt="product.title" :title="product.title" width="72" height="72">
												<span>{{ product.title }}</span>
											</a>
										</div>
									</div>

									<a :href="`/shopall/?keywords=${keywords}`" v-if="results.total_products" class="show-more">{{ $__('strings.text.show_more') }} ({{ results.total_products - results.products.length}})</a>
								</div>
								<div v-if="results.posts && results.posts.length > 0" class="col-md-4 search--results--blog">
									<p v-text="$__('strings.text.search.blog')"></p>
									<div class="megasearch__results--section--wrapper">
										<div class="megasearch__results--element" v-for="(post, index) in results.posts" :key="index">
											<a :href="post.slug" :title="post.title">
												<img loading="lazy" :src="post.picture" :alt="post.title" :title="post.title" width="72" height="72">
												<span>{{ post.title}}</span>
											</a>
										</div>
									</div>

									<a :href="`/news/?keywords=${keywords}`" v-if="results.total_posts" class="show-more">{{ $__('strings.text.show_more') }} ({{ results.total_posts - results.posts.length  }})</a>

								</div>
								<div v-if="searched && results.total == 0" class="col search--noresults">
									<p>{{ $__('strings.text.search.noresults') }} "<span>{{ keywords }}</span>".</p>
								</div>
							</div>
						</perfect-scrollbar>
					</div>
				</div>
			</div>
		</transition>

	</div>
</template>

<script>
import debounce from 'v-debounce';
import { PerfectScrollbar } from 'vue2-perfect-scrollbar'
import 'vue2-perfect-scrollbar/dist/vue2-perfect-scrollbar.css';

export default {
	name: 'Search',
	directives: {debounce},
	components: {
		PerfectScrollbar
	},
	data() {
		return {
			searchShown: false,
			results: {
				categories: null,
				products: null,
				posts: null,
				total: 0,
			},
			keywords: null,
			params: {},
			searched: false
		}
	},
	watch: {
		keywords(before, after) {
			if (this.keywords.length >= 3) {
				this.getResults();

			} else {
				this.results = {
					categories: null,
					products: null,
					posts: null,
					total: 0
				};
				this.searched = false;
			}
		}
	},
	methods: {
		getResults() {
			this.params = { params: { keywords: this.keywords }};
			axios.get('/api/search', this.params)
				.then((response) => {
					this.results = response.data;
					this.searched = true;
				});
		},

		show() {
			this.searchShown = true;
			document.querySelector('html').classList.add('overlay');
			this.$nextTick(() => {
				document.getElementById('searchbar').focus();
			});
		},
		close() {
			this.searchShown = false;
			document.querySelector('html').classList.remove('overlay');
		},
	},
	created () {
		let self = this;
		window.addEventListener('keydown', function (event) {
			if (self.searchShown && event.key === 'Escape') {
				self.close();
			}
		});
	}
}
</script>

